import { ValidatorOptions } from '.';
import { LengthValidator } from './length.validator';
import { RequiredValidator } from './required.validator';
import { ValidationResult } from './types.validators';
import { Validator } from './validator';

export class NumericValidator extends Validator {
    public validate(value: string, options: ValidatorOptions) {
        if (!value || value.length < 1) {
            return new RequiredValidator().validate(value, options);
        }

        const alphaNumericRegex = /^[0-9]*$/;
        const valid = alphaNumericRegex.test(value ?? '');
        const lengthResult = new LengthValidator().validate(value, options);

        if (!lengthResult.isValid) {
            return lengthResult;
        }

        if (!valid) {
            return new ValidationResult(false, 'Please enter a valid numeric value');
        }

        return new ValidationResult(true);
    }
}
